module.exports = __webpack_public_path__ + "static/media/collections.0ce92065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/collections.jpg
// module id = 332
// module chunks = 37